import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog(visibility) {
  const [open, setOpen] = React.useState(visibility);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Documento guardado correctamente"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Este documento ya fue sustituido por otro, por favor verifique.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          '
          <Button sx={{ color: "#000000" }} onClick={handleClose} autoFocus>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
